export default __webpack_public_path__ + "static/media/Logo-Tell.bdedad02.png";